var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1642.48 846.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke:#2e186a;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:6px;}.cls-2{fill:#fe7624;}.cls-3{stroke-width:8px;}.cls-4{fill:#2e186a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "developer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chair",
    className: "cls-1",
    d: "M317.73,731.65l-24.4-194.59c-9.61-76.61,45-138.72,122.06-138.72H544.24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hoodie",
    className: "cls-1",
    d: "M625,394.92l16-22.53-4.21-30.25c-1.13-2.14-2.29-4.37-3.48-6.67-87.37,13-98,49.61-78.38,88.82C410,452.59,346.9,675.05,384.6,780.6c10.74,30,19.36,60,51.27,60.34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tshirt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M670.57,475.79c0-.19,0-.38,0-.57,4.74.46,9.34.49,13.78-3.35,11-9.53,14.9-12.39,14.9-12.39s1,1.2,2.77,3.23c2.17-4,4.43-8.15,6.74-12.35C661.27,413.58,625,394.92,625,394.92L622.32,393l-17.44,21.27S633.26,433.83,670.57,475.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M900.13,821.06s-76-204.39-66.33-267.73c5.27-34.55-3-73.73-14.42-104l-21.77,1.41-26.06,61.62c1.7.42,3.4.77,5.1,1,0,0-1,6.47-3.46,21.34-1.65,9.91,1.18,11,3.42,17.88,2.89,4.63,5.11,9.83,2.67,17.87-.8,2.63-2.7,27.4-7,61,8,17,15.64,34.94,22.8,54,46.08,122.92,41.29,136.33,41.29,136.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hoodie-2",
    "data-name": "hoodie",
    className: "cls-1",
    d: "M1157.5,839.33c-5.47-36-44.48-229.23-267.66-398.72-5-30.28-17.65-77.94-82.66-100.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "string",
    className: "cls-3",
    d: "M851.9,542.57s-2.4,65.28,11.89,112.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stripe",
    className: "cls-4",
    d: "M886.88,439.86c.71,4.26,1.26,8.18,1.79,11.62,6.14,39.82-7,66.26-15.69,84.59,23.33-16.5,39.06-47.88,47-71.81C910.39,456.58,897.3,447.62,886.88,439.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stripe_II",
    "data-name": "stripe II",
    className: "cls-4",
    d: "M557.24,422.52c-16.32,3.33-43.14,11.46-62.47,24.83,13.5,7.36,80.36,47.4,135,71.42.43-.25,3.43-5.25,4.93-7.2C604.46,487.59,572.65,453.41,557.24,422.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ear",
    className: "cls-1",
    d: "M601.25,263.25S564.14,273.31,579.16,305c10.44,22,30.26,14.18,42.08,7.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "cls-1",
    d: "M611.15,269.27l11.66-3.91c7.69,4.65,33.09,36.21,41.28,51.85,0,0,37.29-24.19,95.5-39.66,0,0,31.69-7.24,45.47-6.66-4-32-12.18-72.88-26.58-109.43-21.42-54.33-87.7-33.25-97.32-30-103.37,35.17-70.11,137.58-70.11,137.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beard",
    className: "cls-1",
    d: "M727.49,403.37c-12.44,0-24.27-2.07-33.58-5.75-30.2-11.93-36.62-19.62-47.46-37.76s-44.81-87.39-44.81-87.39l21.17-7.11c7.69,4.65,33.09,36.21,41.28,51.85,0,0,37.29-24.19,95.5-39.66,0,0,32-7.32,45.69-6.66,0,0,6.54,32.54,2.62,64.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-4",
    d: "M604.24,281.52s-19.12-22.17-32.93-48.66c-13-24.9-7.61-55.75,13.94-73.75C603.29,144,620.46,148,620.46,148s-31.06-31.64-6.57-72.57a61.32,61.32,0,0,1,39.38-28.38c40.2-8.81,61,21.85,61,21.85s23.1-89.19,122.31-64.65c10,2.48,23.23,13.06,30.2,20.66C909,71,829.46,158,781.07,175.42c-53.13,19.12-87.3,18.07-108.18,9.13C687.9,189.12,688.45,273.79,604.24,281.52Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "nose",
    className: "cls-3",
    points: "757.57 253.95 776.31 303.81 757.05 303.71"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "mouth",
    className: "cls-4",
    cx: 747.28,
    cy: 337.55,
    r: 9.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II",
    "data-name": "eye II",
    className: "cls-4",
    cx: 777.71,
    cy: 249.86,
    rx: 5.42,
    ry: 8.39,
    transform: "translate(-37.39 196.21) rotate(-14.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye",
    className: "cls-4",
    cx: 726.86,
    cy: 261.64,
    rx: 5.42,
    ry: 8.39,
    transform: "translate(-41.77 184.22) rotate(-14.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II",
    "data-name": "brow II",
    className: "cls-3",
    d: "M693.66,229.94a24.85,24.85,0,0,1,20.58-14.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow",
    className: "cls-3",
    d: "M762.32,202.32s13.64-7.43,20.27,3.58"
  })), /*#__PURE__*/React.createElement("path", {
    id: "laptop",
    className: "cls-4",
    d: "M1354,562.9H965.2a11,11,0,0,0-10.7,8.47L900.44,800.19H759.51s-7.81,40.34,37.73,40.34h496.39a11,11,0,0,0,10.7-8.47l60.39-255.63A11,11,0,0,0,1354,562.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "code_lines",
    "data-name": "code lines"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1191.7,
    y: 206.24,
    width: 13.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 206.24,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 289.34,
    width: 97.93,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1121.64,
    y: 261.67,
    width: 151.89,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1282.03,
    y: 261.67,
    width: 82.04,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1378.78,
    y: 234.01,
    width: 13.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 233.96,
    width: 157.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1210.52,
    y: 206.24,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1260.97,
    y: 233.9,
    width: 110.79,
    height: 18,
    rx: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "code_lines-2",
    "data-name": "code lines"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 385.61,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 468.71,
    width: 97.93,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1121.64,
    y: 441.05,
    width: 151.89,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1282.03,
    y: 441.05,
    width: 82.04,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1378.78,
    y: 413.38,
    width: 13.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1401.62,
    y: 385.61,
    width: 13.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 413.33,
    width: 157.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1191.7,
    y: 385.61,
    width: 108.62,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1307.24,
    y: 385.61,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1191.7,
    y: 358.8,
    width: 13.06,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1096.88,
    y: 358.8,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1210.52,
    y: 358.8,
    width: 89.8,
    height: 17.89,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1260.97,
    y: 413.28,
    width: 110.79,
    height: 18,
    rx: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    id: "handle",
    className: "cls-1",
    d: "M1484.34,735.41a26.47,26.47,0,0,1,6.76-1.41,26.07,26.07,0,1,1-2.15,51.76"
  }), /*#__PURE__*/React.createElement("line", {
    id: "spoon",
    className: "cls-1",
    x1: 1421.52,
    y1: 738.81,
    x2: 1384.25,
    y2: 693.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "mug-2",
    "data-name": "mug",
    className: "cls-4",
    d: "M1378.78,724.71v85.81a30,30,0,0,0,30,30h50.6a30,30,0,0,0,30-30V724.71Zm44.74,62.83a2,2,0,0,1,1,1.76,2,2,0,0,1-2,2,2,2,0,0,1-1-.25l-20-12a2,2,0,0,1,0-3.62l20-12a2,2,0,0,1,1-.25,2,2,0,0,1,2,2,2,2,0,0,1-1,1.76l-17.21,10.32Zm25-29.58-16.1,40.25a2.09,2.09,0,0,1-.4.55,2,2,0,0,1-1.43.6,2,2,0,0,1-2-2,2,2,0,0,1,.18-.85l16.1-40.25a2.08,2.08,0,0,1,.43-.58,1.89,1.89,0,0,1,1.41-.58,2,2,0,0,1,2,2A2.11,2.11,0,0,1,1448.52,758ZM1475.77,779l-20,12a2,2,0,0,1-1,.25,2,2,0,0,1-2-2,2,2,0,0,1,1-1.76L1471,777.23l-17.21-10.32a2,2,0,0,1-1-1.76,2,2,0,0,1,.59-1.42,2,2,0,0,1,1.43-.59,2,2,0,0,1,1,.25l20,12a2,2,0,0,1,0,3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tea"
  }, /*#__PURE__*/React.createElement("path", {
    id: "handle-2",
    "data-name": "handle",
    className: "cls-1",
    d: "M245.2,786a26.07,26.07,0,1,1-3.83-52,25.69,25.69,0,0,1,4.73.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ug",
    className: "cls-4",
    d: "M241.81,724.71v85.81a30,30,0,0,0,30,30h50.61a30,30,0,0,0,30-30V724.71Zm44.75,62.83a2,2,0,0,1,1,1.76,2,2,0,0,1-2,2,2,2,0,0,1-1-.25l-20-12a2,2,0,0,1,0-3.62l20-12a2,2,0,0,1,1-.25,2,2,0,0,1,2,2,2,2,0,0,1-1,1.76l-17.21,10.32Zm42.18-8.5-20,12a2,2,0,0,1-1,.25,1.91,1.91,0,0,1-1.42-.59,1.93,1.93,0,0,1-.59-1.42,2,2,0,0,1,1-1.76l17.21-10.31-17.21-10.32a2,2,0,0,1-1-1.76,2,2,0,0,1,2-2,2,2,0,0,1,1,.25l20,12a2,2,0,0,1,0,3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "soda"
  }, /*#__PURE__*/React.createElement("line", {
    id: "line",
    className: "cls-1",
    x1: 427.34,
    y1: 690.13,
    x2: 413.67,
    y2: 665.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "line-2",
    "data-name": "line",
    className: "cls-1",
    x1: 396.99,
    y1: 692.78,
    x2: 472.76,
    y2: 692.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "can"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M462.27,773.58a5.9,5.9,0,1,0,1.71,4.15A5.69,5.69,0,0,0,462.27,773.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M458.11,764.82A5.87,5.87,0,1,0,454,763.1,5.65,5.65,0,0,0,458.11,764.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M462.27,800.67a5.9,5.9,0,1,0-4.16,1.71A5.68,5.68,0,0,0,462.27,800.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.21,710.88l-13.29-17.29H402.83l-13.29,17.29a9.15,9.15,0,0,0-2,5.61V821.75A9.84,9.84,0,0,0,392.5,830c4.11,2.56,9.35,6.52,9.72,10.31h65.31c.36-3.79,5.6-7.75,9.71-10.31a9.84,9.84,0,0,0,4.93-8.27V716.49A9.2,9.2,0,0,0,480.21,710.88Zm-27.82,20.19,7-11.68a1.21,1.21,0,0,1,1-.65,1.23,1.23,0,0,1,1.06.65l7,11.68a1.15,1.15,0,0,1,.15.59,1.11,1.11,0,0,1-.34.82,1.14,1.14,0,0,1-.83.35,1.19,1.19,0,0,1-1-.6l-6-10-6,10a1.2,1.2,0,0,1-1,.6,1.14,1.14,0,0,1-.83-.35,1.12,1.12,0,0,1-.35-.82A1.15,1.15,0,0,1,452.39,731.07Zm.46,4.4a1.12,1.12,0,0,1,.69-.22,1.14,1.14,0,0,1,.83.35,1.12,1.12,0,0,1,.34.83,1,1,0,0,1-.31.77l-.44.43a5.67,5.67,0,0,0-1.72,4.15,5.12,5.12,0,0,0,1.53,3.89,1.55,1.55,0,0,0,1,.35,1,1,0,0,0,.94-.72l2.39-7.22a5.14,5.14,0,0,1,1.05-1.86,3.32,3.32,0,0,1,2.48-1,3.5,3.5,0,0,1,2.54,1.08,7.41,7.41,0,0,1,2.15,5.52,8.14,8.14,0,0,1-2.95,6.31.94.94,0,0,1-.69.22,1.16,1.16,0,0,1-1.17-1.17,1,1,0,0,1,.31-.78l.44-.43a5.66,5.66,0,0,0,1.71-4.15,5.11,5.11,0,0,0-1.52-3.89,1.57,1.57,0,0,0-1-.35,1,1,0,0,0-.94.72l-2.4,7.22a5.15,5.15,0,0,1-1,1.86,3.32,3.32,0,0,1-2.48,1,3.5,3.5,0,0,1-2.54-1.08,7.41,7.41,0,0,1-2.15-5.52A8.13,8.13,0,0,1,452.85,735.47Zm-.55,17.67a8.23,8.23,0,1,1-2.4,5.81A7.91,7.91,0,0,1,452.3,753.14Zm-2.06,51.25a1.18,1.18,0,0,1,.83-2h1.29a8.23,8.23,0,1,1,5.75,2.35h-7A1.13,1.13,0,0,1,450.24,804.39Zm18.29,4.45-7,11.68a1.23,1.23,0,0,1-1.06.65,1.21,1.21,0,0,1-1-.65l-7-11.68a1.15,1.15,0,0,1-.15-.59,1.12,1.12,0,0,1,.35-.82,1.1,1.1,0,0,1,.83-.35,1.2,1.2,0,0,1,1,.6l6,10,6-10a1.19,1.19,0,0,1,1-.6,1.18,1.18,0,0,1,1.17,1.17A1.15,1.15,0,0,1,468.53,808.84Zm4.53-23.23a1.13,1.13,0,0,1-.83.34H458.11a8.21,8.21,0,1,1,5.82-2.41l-.06.06h8.36a1.14,1.14,0,0,1,.83.35,1.13,1.13,0,0,1,.35.83A1.16,1.16,0,0,1,473.06,785.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumb",
    className: "cls-1",
    d: "M728.2,413.19c.41-12.93.21-33.28-4.38-42.17-7.29-14.11-.49-29.17,14.42-13.76,8.5,8.78,12.67,20.43,14.69,28.82"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 854.1,
    cy: 366.37,
    r: 26.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "sleeve",
    className: "cls-1",
    d: "M685.24,843.52c76.2-5.69,91.36-264.23,94-273.06,5.29-17.44-11.32-21.53-9.14-35.34s.49-20,.49-20c-35.77-5.82-70.51-50.8-70.51-50.8s-3.6,2.63-13.85,11.39-21.69-4.7-33.39,8.72C645.12,493.38,561,634.6,561,634.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "welt",
    className: "cls-4",
    d: "M773.19,534.71c2.48-14.87,3.46-21.34,3.46-21.34-38.09-5.86-77.37-53.89-77.37-53.89s-3.88,2.86-14.9,12.39c-4.44,3.84-9,3.81-13.78,3.35-3.37,41.71,71.45,78.84,106.89,80.59C775.23,545.79,771.32,546,773.19,534.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-3",
    "data-name": "line",
    className: "cls-1",
    d: "M511.48,610.91s45.1-38.92,71.28-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-2",
    "data-name": "hand",
    className: "cls-1",
    d: "M684.44,495.72,760,539.65l37.82-89.42c36.49.06,36.33-19.76,28.69-20.44s-44.33,4.47-44.33,4.47,1.19-2.67,31-8.33,24.21-22.27,17.8-22.72-53.78,11.42-53.78,11.42l40.7-14.53c14.49-4.6,15-18.64,7.43-20.62-5-1.31-31.66,6.75-52.76,14.13,0,0,25.36-13,37.39-20.86s3.62-18.11-3.41-17.47-55.87,33.3-65.17,41.39S684.44,495.72,684.44,495.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coffe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "handle-3",
    "data-name": "handle",
    className: "cls-1",
    d: "M635.24,734.65a27.18,27.18,0,0,1,4.18-.65,26.07,26.07,0,1,1-5.77,50.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mug-3",
    "data-name": "mug",
    className: "cls-4",
    d: "M527.1,724.71v85.81a30,30,0,0,0,30,30h50.6a30,30,0,0,0,30-30V724.71Zm44.74,62.83a2,2,0,0,1,1,1.76,2,2,0,0,1-2,2,2,2,0,0,1-1-.25l-20-12a2,2,0,0,1,0-3.62l20-12a2,2,0,0,1,1-.25,2,2,0,0,1,1.42.59,1.91,1.91,0,0,1,.59,1.42,2,2,0,0,1-1,1.76l-17.21,10.32Zm25-29.58-16.1,40.25a2.13,2.13,0,0,1-.41.55,2,2,0,0,1-1.43.6,2,2,0,0,1-2-2,2.19,2.19,0,0,1,.17-.85l16.1-40.25a2.29,2.29,0,0,1,.43-.58,1.92,1.92,0,0,1,1.41-.58,2,2,0,0,1,2,2A2.27,2.27,0,0,1,596.85,758ZM624.09,779l-20,12a2,2,0,0,1-1,.25,2,2,0,0,1-2-2,2,2,0,0,1,1-1.76l17.2-10.31-17.2-10.32a2,2,0,0,1-1-1.76,1.91,1.91,0,0,1,.59-1.42,2,2,0,0,1,1.42-.59,2,2,0,0,1,1,.25l20,12a2,2,0,0,1,0,3.62Z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "line-4",
    "data-name": "line",
    className: "cls-1",
    x1: 3,
    y1: 843.03,
    x2: 1639.48,
    y2: 843.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M853.73,417l-5.54-85.63-110.37,7.15,3.75,57.94c9.81-8.39,58-40.57,64.95-41.2s15.44,9.62,3.41,17.47-37.39,20.86-37.39,20.86c21.1-7.38,47.79-15.44,52.76-14.13,7.58,2,7.06,16-7.43,20.62l-40.7,14.53s47.37-11.87,53.78-11.42,12,17.06-17.8,22.72-31,8.33-31,8.33,36.7-5.16,44.33-4.47,7.8,20.5-28.69,20.44l-.21.49,28.12-1.82A30,30,0,0,0,853.73,417Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.bb63ce7e0b3feba8ebc7c7f00dd7ffc6.svg";
export { ForwardRef as ReactComponent };